import script from "./LightDevicesSettingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LightDevicesSettingPage.vue?vue&type=script&setup=true&lang=js"

import "./LightDevicesSettingPage.vue?vue&type=style&index=0&id=cfcb6182&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfcb6182"]])

export default __exports__